module.exports = __webpack_public_path__ + "img/i-home.a05b883a.svg";